import { getData } from 'controller/location/getData'

import { getBulkData } from './getBulkData'

export const LocationController = {
  getData,
  getBulkData,
}
